import { render, staticRenderFns } from "./SwitchGestorField.vue?vue&type=template&id=1e60fd36&scoped=true&"
import script from "./SwitchGestorField.vue?vue&type=script&lang=js&"
export * from "./SwitchGestorField.vue?vue&type=script&lang=js&"
import style0 from "./SwitchGestorField.vue?vue&type=style&index=0&id=1e60fd36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e60fd36",
  null
  
)

export default component.exports